import { Switch as MuiSwitch, withStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import { withDefaults } from '../utils';
export const Switch = withStyles((theme) => ({
    checked: {},
    disabled: {},
    track: {
        backgroundColor: theme.palette.grey[500],
    },
    colorSecondary: {
        color: theme.palette.common.white,
        '&$checked': {
            color: theme.palette.secondary.light,
            '&:hover': {
                backgroundColor: alpha(theme.palette.secondary.light, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        '&$disabled': {
            color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
        },
        '&$checked + $track': {
            backgroundColor: theme.palette.secondary.light,
        },
        '&$disabled + $track': {
            backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
        },
    },
}))(withDefaults(MuiSwitch, { color: 'secondary' }));
//# sourceMappingURL=Switch.js.map